import { useQuery } from "react-query";

import axios from "axios";
import { SAM_SERVICE_URI } from "constants/app.constants";

const useChartStatsQuery = (wellList) => {
  const { data, refetch: updateData } = useQuery(
    ["sam-stats", wellList],
    async () => {
      const response = await axios.post(`${SAM_SERVICE_URI}/SamChart/chart-stat`, {
        Ooip: 0,
        PoreVolume: 0,
        ShowForecast: true,
        WellPairUwis: wellList
      });
      if (response.status === 200) {
        return response.data;
      }
      return {};
    },
    {
      enabled: !!wellList?.length,
      staleTime: 0,
      cacheTime: 0
    }
  );

  return { data, updateData };
};

export default useChartStatsQuery;
